'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { hasDemoScope } from 'AdsUI/selectors/AuthSelectors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ScopeWrapper from 'AdsUI/components/ScopeWrapper';
import UIButton from 'UIComponents/button/UIButton';

const RenderCampaignButton = ({
  history,
  isInDropdown,
  disabled
}) => /*#__PURE__*/_jsx(UIButton, {
  use: "primary",
  onClick: () => history.push('/campaigns/new'),
  "data-test-id": "create-ad-campaign",
  size: "small",
  disabled: disabled,
  children: isInDropdown ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "createDropdown.campaign"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "createCampaignButton"
  })
});

const CreateCampaignButton = ({
  history,
  isDemoUser,
  isInDropdown = false
}) => {
  if (isDemoUser) {
    return /*#__PURE__*/_jsx(RenderCampaignButton, {
      history: history,
      isInDropdown: isInDropdown
    });
  }

  return /*#__PURE__*/_jsx(ScopeWrapper, {
    tooltipKey: "createCampaigns",
    children: /*#__PURE__*/_jsx(RenderCampaignButton, {
      history: history,
      isInDropdown: isInDropdown
    })
  });
};

CreateCampaignButton.propTypes = {
  isInDropdown: PropTypes.bool,
  isDemoUser: PropTypes.bool,
  history: PropTypes.object.isRequired
};
export default withRouter(connect(state => ({
  isDemoUser: hasDemoScope(state)
}))(CreateCampaignButton));